import React from 'react';

import { ChangeHandler } from 'src/presentation/components/pages/integrations/types';
import CompactSection from 'src/presentation/components/pages/integrations/editorComponents/CompactSection';
import { Row } from 'src/presentation/components/forms/Layout';
import {
  MaskedField,
  WrappedField,
} from 'src/presentation/components/pages/integrations/editorComponents/EditorFields';

function renderRechargeConfiguration(onChange: (attr: string) => ChangeHandler, maskedFields: string[]): JSX.Element {
  return (
    <>
      <CompactSection
        description={`The Recharge app enriches your customer pages with customer details and subscription information pulled from your Recharge instance.`}
      >
        <Row>
          <WrappedField
            attr="name"
            label="Name"
            placeholder="App Name"
            description="This is the name that will be displayed throughout Gladly"
            data-aid="recharge-integration-name"
            autoFocus={true}
            onChange={onChange('name')}
          />
        </Row>
        <Row>
          <MaskedField
            attr="secrets.token"
            label="Recharge Private Token"
            description="This field is used to authenticate Recharge requests"
            data-aid="recharge-token"
            onChange={onChange('secrets.token')}
            showClearButton={maskedFields.includes('token')}
            isMasked={maskedFields.includes('token')}
          />
        </Row>
      </CompactSection>
    </>
  );
}

export default renderRechargeConfiguration;
